import { Component, OnInit } from '@angular/core';
import { HighlightService } from 'src/app/@core/services/highligh.service';
import { environment } from './../../../environments/environment';
import { ToolsService } from 'src/app/@core/services/tools.service';
@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss']
})
export class InicioComponent implements OnInit {

  utils: any;
  highlighted: boolean = false;
  implementHref: string = `${environment.server}/${environment.version}/assets/html/implementacion.html`
  codeList = {
    CDNcss:
      `<!-- css CDN -->
<link href="${environment.server}/${environment.version}/${environment.assetCdnCssMin}" rel="stylesheet">`,
    utilsImport:
      `<!-- utils.js CDN -->
<script src="${environment.server}/${environment.version}/${environment.assetCdnJS}"></script>`,
    bootstrapJs:
      `<!-- js bootstrap -->
<script src="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/js/bootstrap.min.js"
    integrity="sha384-JjSmVgyd0p3pXB1rRibZUAYoIIy6OrQ6VrjIEaFf/nJGzIxFDsf4x0xIM+B07jRM"
    crossorigin="anonymous">
</script>`,
    bootstrapCss:
      `<!-- css bootstrap -->
<link href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" rel="stylesheet" 
    integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T"
crossorigin="anonymous" />`,
    jqueryJs:
      `<!-- js jquery -->
<script src="https://code.jquery.com/jquery-3.4.1.min.js" 
    integrity="sha256-CSXorXvZcTkaix6Yvo6HppcZGetbYMGWSFlBw8HfCJo=" crossorigin="anonymous"></script>`,
    jqueryDatatable:
      `<!-- js jquery datatable -->
 <script src="https://cdn.datatables.net/1.10.20/js/jquery.dataTables.min.js"></script>`,
    DatepickerJs:
      `<!-- js Datepicker  -->
<script src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/js/bootstrap-datepicker.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/locales/bootstrap-datepicker.es.min.js"></script>`,
    DatepickerCss:
      `<!-- Css Datepicker  -->
    <link rel="stylesheet" href="https://cdn.datatables.net/1.10.20/css/jquery.dataTables.min.css" />
    `,
    jqueryCss:
      `<!-- css jquery datatable -->
<link rel="stylesheet" href="https://cdn.datatables.net/1.10.20/css/jquery.dataTables.min.css" />
      `,
    utilsjs: `
import { utils } from 'assets/js/utils.js';

const MAX_CHARACTERS = 15;
// uso de la función de contar caracteres; 
utils.countCharacter("input_con_contador", MAX_CHARACTERS);
      `,
  };



  infoComponent: { titulo: string; descripcion: string; };
  constructor(private highlightService: HighlightService) {
    this.utils = window.utils;

    this.infoComponent = {
      titulo: "Textarea",
      descripcion: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit voluptas quia dolorem sit totam soluta culpa eius, aspernatur magni consequuntur magnam accusamus fugiat! Quibusdam accusantium labore facere id perferendis!"
    }
  }

  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }

  ngOnInit() {
    this.utils.init();
  }
  
}
